module.exports = __webpack_public_path__ + "img/201902.47c3ea36.png";